// extracted by mini-css-extract-plugin
export default {"title":"PositionTrackerChart_title__uX4dD"};